/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Filter for symbol offset. */
@cc._decorator.ccclass
export default class RequiredSymbolOffsetFilter extends StreakTrackerFilterBase
{
    /** Minimum offset in range. */
    @property({ type: cc.Integer, visible: true })
    private _minOffset: number = 0;
    /** Public access for minimum offset. */
    public get MinOffset(): number { return this._minOffset; }

    /** Max offset in range. */
    @property({ type: cc.Integer, visible: true })
    private _maxOffset: number = 0;
    /** Public getter for maximum offset. */
    public get MaxOffset(): number { return this._maxOffset; }

    /** When false will return empty array on first mismatched result. */
    @property({ visible: true })
    private _processEntireResult: boolean = false;
    /** Public getter for process entire result. */
    public get ProcessEntireResult(): boolean { return this._processEntireResult; }
    /** Public setter for process entire result. */
    public set ProcessEntireResult(value: boolean) { this._processEntireResult = value; }

    /** Filter out symbols not in offset range. */
    public Filter = (symbols: ISymbolData[]) =>
    {
        let validSymbols: ISymbolData[] = [];

        for (let symbol of symbols)
        {
            if (symbol.OffSet < this._minOffset || symbol.OffSet > this._maxOffset)
            {
                if (!this._processEntireResult) { return []; }

                continue;
            }

            validSymbols.push(symbol);
        }

        return validSymbols;
    }
}
